import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthCallback from "./auth/AuthCallback";
import { AuthProvider } from "./auth/AuthContext";
import AuthPage from "./auth/AuthPage";
import ForgotPasswordPage from "./auth/ForgotPasswordPage";
import ProtectedRoute from "./auth/ProtectedRoute";
import ResetPasswordPage from "./auth/ResetPasswordPage";
import AdminRoute from "./auth/AdminRoute";
import HomeRedirect from "./auth/HomeRedirect";
import BadgeEditor from "./components/BadgeEditor";
import FeedbackButton from "./components/FeedbackButton";
import EventEditorPage from "./events/EventEditorPage";
import EventsListPage from "./events/EventsListPage";
import NewEventPage from "./events/NewEventPage";
import AdminPage from "./admin/AdminPage";

import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/events" element={<EventsListPage />} />
            <Route path="/events/new" element={<NewEventPage />} />
            <Route path="/events/:eventId" element={<EventEditorPage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminPage />} />
            </Route>
          </Route>
          <Route
            path="/demo"
            element={
              <BadgeEditor mode="demo" isDemoMode />
            }
          />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer style={{ zIndex: 10001 }} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
